<template>
  <div>
    <div class="forgot-pass-box text-center">
      <div class="forgot-pwd-title">{{ formHeaderText }}</div>
      <div class="forgot-pwd-wrapper" :class="isVerificationPhone ? 'no-padding' : ''">
        <p class="forgot-pwd-text mb-7 pl-0 pr-0">{{ formHelpText }}</p>
        <div class="form-group">
          <template v-if="!isVerificationPhone">
            <input
              type="email"
              v-validate="'required|email'"
              name="email"
              :class="{
                input: true,
                'is-danger': errors.has('email'),
                'is-success': !errors.has('email')
              }"
              class="form-control"
              v-model="email"
              required
              autocomplete="false"
            />
            <label v-translate:email="lang">Email</label>
          </template>
          <vue-tel-input
            class="mb-0 mr-0 "
            v-else
            wrapperClasses="vue-tel-macho-style input-empty"
            v-model="verificationPhone"
            :dropdownOptions="{ showDialCodeInSelection: true }"
            mode="national"
            @onInput="phoneValidated"
            @country-changed="countryChanged"
            @validate="phoneValidated"
            v-vue-tel-label="widget.translate('verification_phone_number_mobile', 'Verification Phone Number (Mobile)')"
            validCharactersOnly
            type="tel-input"
            name="phoneNumber"
            enabledCountryCode
            defaultCountry="us"
            :preferredCountries="['us']"
            :class="{
              input: true,
              'is-danger': errors.has('phoneNumber'),
              'is-success': !errors.has('phoneNumber')
            }"
          >
          </vue-tel-input>
        </div>

        <div class="text-center forgot-pwd-btn">
          <div class="pb-27 forgot-link" v-if="!selectVerificationPhone">
            <a class="text-center cursor_pointer verificationPhoneClickText" v-if="verificationPhoneClickText != ''" @click="switchToVerificationPhone()">{{ verificationPhoneClickText }}</a>
          </div>
          <button type="submit" class="btn btn-submit primary-bg" v-on:click.prevent="() => (isVerificationPhone ? verifyPhone() : verifyEmail())" :disabled="isVerificationPhone ? !phoneObject.valid : !email || errors.has('email')">
            {{ submitBtnTitle }}
          </button>
        </div>
      </div>
    </div>
    <Modal :show="showVerificationSentModal" :cancelButton="modal.cancelBtnTitle" :title="modal.title" :helpText="modal.helpText" :okButton="modal.okBtnTitle" @modalCallback="modalCallback" @cancelled="cancelBtnCallback"></Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Widget, ParticipantPortal } from "@/components/services/participant-service";
import Modal from "@/components/participant-portal/common/modal";
import { Auth } from "aws-amplify";

export default {
  name: "auth-verify-email",
  props: ["buttonTitle", "navTitle", "isOnBackClick", "lang", "eventType"],
  components: { Modal },
  data() {
    return {
      email: "",
      phoneObject: { valid: false },
      widget: new Widget(),
      portal: new ParticipantPortal(),
      selectVerificationPhone: false,
      verificationPhone: "",
      clickedBackOnce: false,
      forgotUsername: {
        language: null,
        studyId: "0",
        deviceType: "web"
      },
      showVerificationSentModal: false,
      isUsernameSent: false,
      modal: {
        title: "",
        helpText: "",
        okBtnTitle: "",
        cancelBtnTitle: ""
      }
    };
  },
  beforeDestroy() {
    this.$root.$off("onVerifyMethodBackBtnClicked", null);
  },
  mounted() {
    this.$root.$on("onVerifyMethodBackBtnClicked", () => {
      if (!this.clickedBackOnce) {
        this.clickedBackOnce = true;
        this.selectVerificationPhone = false;
      } else {
        this.$router.push({ name: "participants-portal-auth-login" });
      }
    });
  },
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    submitBtnTitle() {
      return this.buttonTitle ? this.buttonTitle : this.widget.translate("label_submit", "Submit");
    },
    isVerificationPhone() {
      return this.selectVerificationPhone;
    },
    formHeaderText() {
      return this.isVerificationPhone ? this.widget.translate("label_enter_verification_phone", "Enter Verification Phone Number (Mobile)") : this.navTitle;
    },
    formHelpText() {
      return this.isVerificationPhone ? this.widget.translate("pweb_help_text_verify_phone", "Please enter the Verification Phone Number (Mobile) associated with your account and a verification code will be sent to you.") : this.widget.translate("pweb_help_text_verify_email", "Please enter the email address associated with your account and a verification code will be sent to you.");
    },
    verificationPhoneClickText() {
      return this.pwebCognitoAuthentication && this.eventType == "username" && this.portal.getVerificationMethod() != "email" ? this.widget.translate("retrieve_username_with_verification_phone", "Retrieve Username with Verification Phone") : "";
    }
  },
  methods: {
    //TUR-61129
    switchToVerificationPhone() {
      this.clickedBackOnce = false;
      this.selectVerificationPhone = true;
    },
    verifyPhone() {
      const postCognitoData = {
        mobile: this.phoneObject.number.significant,
        countryCode: "+" + this.phoneObject.country.dialCode,
        languageId: this.portal.getLanguage(),
        email: this.email.toLowerCase(),
        deviceType: "web",
        studyId: this.portal.getStudy() ? this.portal.getStudy() : null,
        otpType: "CREATE_USERNAME"
      };
      if (this.eventType == "password" && this.isVerificationPhone) {
        this.$emit("updateActiveScreen", {
          key: "verifyOtp",
          flagKey: "resetPassword",
          flagChild: "email",
          flagValue: this.phoneObject,
          verificationPhone: "phone"
        });
      } else {
        this.setModalDetails();
        this.$api.sendOtpToVerifyEmail(postCognitoData).then(
          response => {
            if (response.body.errorCode != null && (response.body.errorMessage === "PHONE_NOT_FOUND" || response.body.errorMessage === "lable_phone_no_privilege")) {
              this.showNoPrivilege(response);
            } else if (response.body.errorMessage == "lable_phone_no_privilege_new") {
              this.modal.title = this.widget.translate("lable_phone_no_privilege", "This phone number does not have verification privileges.");
              this.modal.helpText = this.widget.translate("lable_try_with_diffrent_phone", "Please try retrieving your username using a different method.");
              this.modal.okBtnTitle = this.widget.translate("label_ok", "OK");
              this.showVerificationSentModal = true;
              return;
            } else if (response.body.errorMessage) {
              const title = this.widget.translate(response.body.errorMessage, response.body.message);
              this.$toastr.error(title);
            } else {
              this.$emit("updateActiveScreen", {
                key: "verifyOtp",
                flagKey: "createUsername",
                flagChild: "email",
                mobile: this.phoneObject,
                verificationPhone: "phone"
              });
            }
          },
          error => {
            if (error.body.errorCode != null && (error.body.errorMessage === "PHONE_NOT_FOUND" || error.body.errorMessage === "lable_phone_no_privilege")) {
              this.showNoPrivilege(error);
              return;
            } else if (error.body.errorMessage) {
              const title = this.widget.translate(error.body.errorMessage, error.body.message);
              this.$toastr.error(title);
              return;
            } else {
              const title = this.widget.translate("PARTICIPANT_NOT_FOUND", "No record found for the participant.");
              this.$toastr.error(title);
              return;
            }
          }
        );
      }
    },
    showNoPrivilege() {
      this.modal.title = this.widget.translate("label_verification_priveleges_error", "This phone number does not have verification privileges.");
      this.modal.helpText = "";
      this.modal.okBtnTitle = this.widget.translate("label_ok", "OK");
      this.showVerificationSentModal = true;
    },
    onInpuPhoneNumber(data, phoneObject) {
      this.phoneObject = phoneObject;
    },
    phoneValidated(phoneObject) {
      this.phoneObject = phoneObject;
    },
    countryChanged() {
      this.phoneValidated(this.phoneObject);
    },
    //TUR-61129
    setModalDetails(usernameStatus) {
      if (this.eventType == "username") {
        if (usernameStatus == "USERNAME_SENT") {
          this.modal.title = this.widget.translate("pweb_title_username_sent", "Username Sent");
          this.modal.helpText = this.widget.translate("pweb_help_text_username_sent", "An email has been sent with the associated username(s).");
          this.modal.cancelBtnTitle = null;
          this.modal.okBtnTitle = this.widget.translate("label_ok", "OK");
        } else if (usernameStatus == "USER_DOES_NOT_HAVE_USERNAME") {
          this.modal.title = this.widget.translate("pweb_title_forgot_username_not_found", "There is no username associated to this account.");
          this.modal.helpText = this.widget.translate("pweb_help_text_forgot_username_not_found", "Would you like to create one now?");
          this.modal.cancelBtnTitle = this.widget.translate("label_cancel", "Cancel");
          this.modal.okBtnTitle = this.widget.translate("YES_TEXT", "Yes");
        } else {
          this.modal.title = this.widget.translate("pweb_title_verification_code_sent", "Verification Code Sent");
          this.modal.helpText = this.widget.translate("pweb_help_text_verification_code", "A verification code has been sent to the email address you just provided.");
          this.modal.okBtnTitle = this.widget.translate("label_ok", "OK");
        }
      } else {
        this.modal.title = this.widget.translate("pweb_title_verification_code_sent", "Verification Code Sent");
        this.modal.helpText = this.widget.translate("pweb_help_text_verification_code", "A verification code has been sent to the email address you just provided.");
        this.modal.okBtnTitle = this.widget.translate("label_ok", "OK");
      }
    },
    verifyEmail() {
      const postCongitoData = {
        languageId: this.portal.getLanguage(),
        email: this.email.toLowerCase(),
        deviceType: "web",
        otpType: "CREATE_USERNAME"
      };
      if (this.pwebCognitoAuthentication) {
        if (this.eventType == "password") {
          this.forgotPasswordCognito(postCongitoData);
        } else {
          postCongitoData.optionalConstraints = "FORGOT_USERNAME";
          this.forgotPassword(postCongitoData);
        }
      } else {
        this.forgotPassword(postCongitoData);
      }
    },
    cancelBtnCallback() {
      if (this.eventType == "username") {
        this.$router.push("login");
      }
    },
    modalCallback() {
      if (this.eventType == "username") {
        if (!this.isVerificationPhone) {
          if (this.usernameStatus == "USERNAME_SENT") {
            this.$router.push("login");
          } else if (this.usernameStatus == "USER_DOES_NOT_HAVE_USERNAME") {
            const postCongitoData = {
              languageId: this.portal.getLanguage(),
              email: this.email.toLowerCase(),
              deviceType: "web",
              otpType: "CREATE_USERNAME"
            };
            const that = this;
            this.$api
              .sendOtpToVerifyEmail(postCongitoData)
              .then(() => {
                that.setModalDetails("");
                that.modal.cancelBtnTitle = "";
                that.usernameStatus = "SINGLE_STUDY";
                that.showVerificationSentModal = !that.showVerificationSentModal;
              })
              .catch(() => {
                const title = this.widget.translate("PARTICIPANT_NOT_FOUND", "No record found for the participant.");
                this.$toastr.error(title);
              });
          } else {
            if (this.usernameStatus == "SINGLE_STUDY") {
              this.$emit("updateActiveScreen", {
                key: "verifyOtp",
                flagKey: "singleStudy",
                flagChild: "email",
                flagValue: this.email
              });
            }
            this.$emit("updateActiveScreen", {
              key: "verifyOtp",
              flagKey: "createUsername",
              flagChild: "email",
              flagValue: this.email
            });
          }
        } else {
          this.$router.push("login");
        }
      } else if (this.eventType == "password") {
        if (!this.isVerificationPhone) {
          this.$emit("updateActiveScreen", {
            key: "verifyOtp",
            flagKey: "resetPassword",
            flagChild: "email",
            flagValue: this.email
          });
        } else {
          this.$emit("updateActiveScreen", {
            key: "verifyOtp",
            flagKey: "resetPassword",
            flagChild: "email",
            flagValue: this.email
          });
        }
      } else {
        this.$emit("updateActiveScreen", {
          key: "verifyOtp",
          flagKey: "resetPassword",
          flagChild: "email",
          flagValue: this.email
        });
      }
    },
    forgotPasswordCognito(postData) {
      Auth.verifyCurrentUserAttribute({ email: postData.email })
        .then(() => {
          this.showVerificationSentModal = !this.showVerificationSentModal;
        })
        .catch(() => {
          const title = this.widget.translate("PARTICIPANT_NOT_FOUND", "No record found for the participant.");
          this.$toastr.error(title);
        });
    },
    forgotPassword(postData) {
      const that = this;
      this.setModalDetails("");
      this.$api.sendOtpToVerifyEmail(postData).then(
        response => {
          if (response.body.errorCode == null) {
            if (response.body.data && response.body.data == "USERNAME_SENT") {
              that.setModalDetails("USERNAME_SENT");
              that.showVerificationSentModal = true;
              that.usernameStatus = "USERNAME_SENT";
            } else {
              that.showVerificationSentModal = !that.showVerificationSentModal;
            }
          } else if (response.body.errorMessage && response.body.errorMessage == "USER_DOES_NOT_HAVE_USERNAME") {
            that.setModalDetails("USER_DOES_NOT_HAVE_USERNAME");
            that.showVerificationSentModal = true;
            that.usernameStatus = "USER_DOES_NOT_HAVE_USERNAME";
          } else if (response.body.errorMessage != null && (response.body.errorMessage == "PARTICIPANT_ACCOUNT_DEACTIVE" || response.body.errorMessage == "EMAIL_NOT_VERIFIED")) {
            const title = this.widget.translate(response.body.errorMessage, response.body.message);
            this.$toastr.error(title);
          } else {
            const title = this.widget.translate("label_user_email_not_found", "Email address not found.");
            this.$toastr.error(title);
          }
        },
        () => {
          const title = this.widget.translate("PARTICIPANT_NOT_FOUND", "No record found for the participant.");
          this.$toastr.error(title);
        }
      );
    }
  }
};
</script>
<style scoped>
.retrieve-by-phone {
  color: var(--secondary);
  margin-bottom: 24px;
}
.forgot-pwd-wrapper.no-padding {
  padding: 0 9px;
}
.forgot-pass-box {
  padding: 70px 30px;
}
.forgot-pass-box .forgot-pwd-text {
  padding: 0 60px 48px 60px;
  max-width: 88%;
  margin: 0 auto;
}
.verificationPhoneClickText {
  color: var(--secondary) !important;
}
</style>
